// extracted by mini-css-extract-plugin
export default {"root":"UncreditedPaymentsList_root__raRvF","root_nothing":"UncreditedPaymentsList_root_nothing__fRrV1"};